(() => {
  'use strict';
  if (!document.body.classList.contains('mz-editorial-store')) return;
  const nativeCart = document.getElementById('sidebar-cart');
  const script = document.currentScript;
  const nativeClose = nativeCart && nativeCart.querySelector('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]');
  const closeLabel = (nativeClose && nativeClose.getAttribute('aria-label')) || (script && script.dataset.closeLabel);
  const title = nativeCart && nativeCart.querySelector('.Drawer__Title');
  const cartTitle = (title && title.textContent.trim()) || (script && script.dataset.cartTitle);
  const enhancedButtons = new WeakSet();
  let appRoot = null;
  let reconciling = false;
  const reconcile = () => {
    if (reconciling || !appRoot) return;
    const appCart = appRoot.querySelector('.eascMiniCartDiv');
    if (!appCart) return;
    const appClose = appCart.querySelector('.closeeascMiniCartDiv');
    if (appClose && !enhancedButtons.has(appClose)) {
      if (!appClose.hasAttribute('role')) appClose.setAttribute('role', 'button');
      if (!appClose.hasAttribute('tabindex')) appClose.setAttribute('tabindex', '0');
      if (closeLabel && !appClose.hasAttribute('aria-label')) appClose.setAttribute('aria-label', closeLabel);
      appClose.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        appClose.click();
      });
      enhancedButtons.add(appClose);
    }
    if (!appCart.hasAttribute('role')) appCart.setAttribute('role', 'dialog');
    if (!appCart.hasAttribute('aria-modal')) appCart.setAttribute('aria-modal', 'true');
    if (cartTitle && !appCart.hasAttribute('aria-label')) appCart.setAttribute('aria-label', cartTitle);
    if (!nativeCart || !nativeClose || nativeCart.getAttribute('aria-hidden') !== 'false') return;
    reconciling = true;
    const moveFocus = nativeCart.contains(document.activeElement);
    nativeClose.click();
    if (moveFocus && appClose && appClose.isConnected) appClose.focus({ preventScroll: true });
    reconciling = false;
  };
  const nativeObserver = new MutationObserver(reconcile);
  if (nativeCart && nativeClose) nativeObserver.observe(nativeCart, { attributes: true, attributeFilter: ['aria-hidden'] });
  const appObserver = new MutationObserver(reconcile);
  const attachApp = () => {
    const root = document.getElementById('ea-sticky-cart-root');
    if (!root || root === appRoot) return false;
    appRoot = root;
    appObserver.disconnect();
    appObserver.observe(root, { childList: true, subtree: true });
    reconcile();
    return true;
  };
  if (!attachApp()) {
    const discoveryObserver = new MutationObserver(() => {
      if (attachApp()) discoveryObserver.disconnect();
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
